// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"modalEdit_modalBodyStyle__F1EEe","modal":"modalEdit_modal__Hdsgv"};